import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import SessionService from '../services/SessionsService';

import DashboardPage from '../pages/DashboardPage/DashboardPage';
import { AdministrationView } from '../pages/DashboardPage/views/AdministrationView/AdministrationView';
import { AgentsView } from '../pages/DashboardPage/views/AgentsView/AgentsView';
import { AgentEditor } from '../pages/DashboardPage/views/AgentsView/components/AgentEditor/AgentEditor';
// Analítica va dentro de Finanzas (INFORMES); se deja por si hay que volver a la ruta propia
// import { AnalyticsView } from '../pages/DashboardPage/views/AnalyticsView/AnalyticsView';
import { BooksView } from '../pages/DashboardPage/views/BooksView/BooksView';
import { DashboardView } from '../pages/DashboardPage/views/DashboardView/DashboardView';
import { DistributionView } from '../pages/DashboardPage/views/DistributionView/DistributionView';
import { EditorialView } from '../pages/DashboardPage/views/EditorialView';
import { FinancesView } from '../pages/DashboardPage/views/FinancesView/FinancesView';
import { GroupsView } from '../pages/DashboardPage/views/GroupsView/GroupsView';
import { RolesView } from '../pages/DashboardPage/views/RolesView/RolesView';
import { SalesChannelView } from '../pages/DashboardPage/views/SalesChannelView/SalesChannelView';
import { UsersView } from '../pages/DashboardPage/views/UsersView/UsersView';
import { WarehousesView } from '../pages/DashboardPage/views/WarehousesView';
import { SocietiesView } from '../pages/DashboardPage/views/SocietiesView';
import { SuppliersView } from '../pages/DashboardPage/views/SuppliersView';
// Activos fijos va dentro de Finanzas (CONTABILIDAD); se deja por si hay que volver a la ruta propia
// import { FixedAssetsView } from '../pages/DashboardPage/views/FixedAssetsView';
import { StockAuditReportView } from '../pages/DashboardPage/views/StockAuditReportView';
import { AuthorsView } from '../pages/DashboardPage/views/AuthorsView';
import { ClientsView } from '../pages/DashboardPage/views/ClientsView';
import { PurchasesView } from '../pages/DashboardPage/views/PurchasesView';
import LoginPage from '../pages/LoginPage/Login';



export const PrivateRoute: React.ComponentType<any> = ({
  component: Component,
  customProps,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={props =>
        SessionService.isAuthenticated() ? (
          <Component {...props} {...customProps} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};

export const RootRoute: React.ComponentType<any> = ({
  component: Component,
  customProps,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={props =>
        SessionService.isAdmin() ? (
          <Component {...props} {...customProps} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location }
            }}
          />
        )
      }
    />
  );
};

export const publicRoutes: Array<RouteProps> = [
  {
    path: '/login',
    component: () => <LoginPage />,
    exact: true
  }
];

export const privateRoutes: Array<RouteProps> = [
  {
    path: '/',
    component: (props: any) => <DashboardPage {...props} />,
    exact: false
  }
];

export const adminRoutes: Array<RouteProps> = [
  // Add admin-only routes here if needed
];

export const dashboardRoutes: Array<RouteProps> = [
  { path: '/', exact: true, component: (props: any) => <DashboardView {...props} /> },
  { path: '/societies', component: (props: any) => <SocietiesView {...props} /> },
  { path: '/users', component: (props: any) => <UsersView {...props} /> },
  { path: '/grupos', component: (props: any) => <GroupsView onMenuOpen={() => { }} menuCloseSignal={0} {...props} /> },
  { path: '/roles', component: (props: any) => <RolesView onMenuOpen={() => { }} menuCloseSignal={0} {...props} /> },
  { path: '/agents', exact: true, component: (props: any) => <AgentsView {...props} /> },
  { path: '/agents/edit/:agentId', component: (props: any) => <AgentEditor {...props} /> },
  { path: '/books', component: (props: any) => <BooksView {...props} /> },
  { path: '/authors', component: (props: any) => <AuthorsView {...props} /> },
  { path: '/editorial', component: (props: any) => <EditorialView {...props} /> },
  { path: '/distribution', component: (props: any) => <DistributionView onSelectShipment={(order) => console.log('Shipment selected:', order)} {...props} /> },
  { path: '/warehouses', component: (props: any) => <WarehousesView {...props} /> },
  { path: '/sales-channels', component: (props: any) => <SalesChannelView {...props} /> },
  { path: '/purchases', component: (props: any) => <PurchasesView {...props} /> },
  { path: '/suppliers', component: (props: any) => <SuppliersView {...props} /> },
  // { path: '/fixed-assets', component: (props: any) => <FixedAssetsView {...props} /> },
  { path: '/stock-audit', component: (props: any) => <StockAuditReportView {...props} /> },
  { path: '/finances', component: (props: any) => <FinancesView privacyMode={false} {...props} /> },
  { path: '/clients', component: (props: any) => <ClientsView {...props} /> },
  // { path: '/analytics', component: (props: any) => <AnalyticsView {...props} /> },
  { path: '/administration', exact: true, component: (props: any) => <AdministrationView {...props} /> },
  { path: '/settings', component: (props: any) => <div className="page-boilerplate"><h2>Configuración</h2><p>Ajustes generales del sistema y preferencias.</p></div> },
  { path: '*', component: (props: any) => <div className="page-boilerplate"><h2>Página no encontrada</h2><p>Seleccione una opción válida en el menú.</p></div> }
];